import { useRef, useState } from "react";
import { Container, Row, Col, Toast } from "react-bootstrap";
import TrackVisibility from "react-on-screen";
import emailjs from "@emailjs/browser";

import contactImg from "../assets/img/contact-img.svg";
import "animate.css";

export const Contact = () => {
  const form = useRef();
  const [buttonText, setButtonText] = useState("Send");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarColor, setSnackbarColor] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();
    setButtonText("Sending...");

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        (result) => {
          setSnackbarMessage("Email sent successfully!");
          setSnackbarColor("green");
          setShowSnackbar(true);
          setButtonText("Send");
          e.target.reset();
        },
        (error) => {
          setSnackbarMessage(
            "Request failed, please try again or contact on the number provided below!"
          );
          setSnackbarColor("red");
          setShowSnackbar(true);
          setButtonText("Send");
        }
      );
  };

  const handleCloseSnackbar = () => {
    setShowSnackbar(false);
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <img
                  className={
                    isVisible ? "animate__animated animate__zoomIn" : ""
                  }
                  src={contactImg}
                  alt="Contact Us"
                />
              )}
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2 className="text-center text-sm-start">Let's Connect!</h2>
                  <p className="text-center text-sm-start">
                    Time to discover new opportunities together.
                  </p>
                  <form ref={form} onSubmit={sendEmail}>
                    <Row>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="text"
                          placeholder="First Name"
                          name="first_name"
                        />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="text"
                          placeholder="Last Name"
                          name="last_name"
                        />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="email"
                          placeholder="Email Address*"
                          name="email"
                          required
                        />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="tel"
                          placeholder="Phone No."
                          name="number"
                        />
                      </Col>
                      <Col
                        size={12}
                        className="d-flex flex-column align-items-end px-1"
                      >
                        <textarea
                          rows="6"
                          placeholder="Message*"
                          name="message"
                        ></textarea>
                        <button type="submit" className="rounded">
                          <span>{buttonText}</span>
                        </button>
                      </Col>
                    </Row>
                  </form>

                  <Toast
                    show={showSnackbar}
                    onClose={handleCloseSnackbar}
                    style={{
                      position: "fixed",
                      backgroundColor: snackbarColor,
                      bottom: "20px",
                      left: "20px",
                      minWidth: "200px",
                      zIndex: 9999,
                    }}
                    delay={2000}
                    autohide
                  >
                    <Toast.Body className="text-white">
                      {snackbarMessage}
                    </Toast.Body>
                  </Toast>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
